import { Divider, Flex, Typography } from 'antd';
import StatusTag from 'components/StatusTag';
import { renderDate, renderInfoValue } from '../../../../utils/helpers';
import { PIPE_STATUS } from '../../helper';
import AvatarBlock from '../AvatarBlock';

const { Text } = Typography;

const EventStatus = ({ title, info, status }) => {
  return (
    <Flex vertical justify="flex-start">
      <Text type="secondary" className="info-window-title--secondary">
        {title}
      </Text>
      <Text className="info-window-text">{info}</Text>

      <Flex gap={1} style={{ marginTop: '4px' }}>
        {status?.map((s, index) => (
          <StatusTag key={s + index} status={s} />
        ))}
      </Flex>
    </Flex>
  );
};

const PipeInfoWindow = ({ marker }) => {
  const className = `${
    marker?.isLate && !marker?.isIncomplete ? 'info-window-late' : ''
  } ${marker?.isIncomplete ? 'info-window-incomplete' : ''}`;
  const title = marker?.label;

  const pipeInstallationStatus = [marker?.installationImageReviewStatus];

  const dryingEventStatus = [];

  if (marker?.reviewStatus && !marker?.isIncomplete) {
    dryingEventStatus?.push(
      marker?.reviewStatus === PIPE_STATUS.APPROVED
        ? PIPE_STATUS.SERVICED
        : marker?.reviewStatus,
    );
  }

  if (marker?.isLate && !marker?.isIncomplete) {
    dryingEventStatus?.push('LATE');
  }

  if (marker?.isUnserviced) {
    dryingEventStatus?.push('NOT_SERVICED');
  }

  if (marker?.isIncomplete) {
    dryingEventStatus?.push('IN_COMPLETE');
  }

  const secondDryingEventStatus = [];

  if (marker?.secondReviewStatus && !marker?.isIncomplete2) {
    secondDryingEventStatus?.push(
      marker?.secondReviewStatus === PIPE_STATUS.APPROVED
        ? PIPE_STATUS.SERVICED
        : marker?.secondReviewStatus,
    );
  }

  if (marker?.isLateDryingEvent2 && !marker?.isIncomplete2) {
    secondDryingEventStatus?.push('LATE');
  }

  if (marker?.isUnserviced2) {
    secondDryingEventStatus?.push('NOT_SERVICED');
  }

  if (marker?.isIncomplete2) {
    secondDryingEventStatus?.push('IN_COMPLETE');
  }

  return (
    <Flex vertical gap={10} className={className}>
      <Flex vertical gap={2}>
        <Text className="info-window-title">{title}</Text>
        <AvatarBlock
          icon={marker?.farmer?.profileImage}
          size={18}
          text={renderInfoValue(marker?.farmer?.name)}
        />
      </Flex>

      <Flex vertical>
        <Text type="secondary" className="info-window-title--secondary">
          Agronomist
        </Text>
        <Text className="info-window-text">
          {renderInfoValue(marker?.agronomist?.name)}
        </Text>
      </Flex>

      <Flex align="flex-start">
        <EventStatus
          title="Installation Date"
          info={renderDate(marker?.installationDate)}
          status={pipeInstallationStatus}
        />
        <Divider style={{ height: '5em' }} type="vertical" />
        <EventStatus
          title={`Drying Event ${marker?.secondDryingEventDueDate ? '1' : ''} Date`}
          info={renderDate(marker?.servicedDate)}
          status={dryingEventStatus}
        />

        {!!marker.secondDryingEventDueDate && (
          <>
            <Divider style={{ height: '5em' }} type="vertical" />
            <EventStatus
              title="Drying Event 2 Date"
              info={renderDate(marker?.secondServicedDate)}
              status={secondDryingEventStatus}
            />
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default PipeInfoWindow;
